import { configureStore } from "@reduxjs/toolkit";
import {
  userReducer,
  authReducer,
  roleReducer,
  navigationReducer,
  employeeReducer,
  roleUserReducer,
  roleDetailReducer,
  dictionaryReducer,
  approvalReducer,
  leaveReducer,
  symbolReducer,
  overtimeReducer,
  timekeepingReducer,
  timesheetReducer,
  transactionReducer,
  payslipReducer,
  middlewareReducer,
  departmentReducer,
  announcementReducer,
  announcementUserReducer,
  shiftReducer,
  periodReducer,
  settingReducer,
  permissionReducer,
} from "./reducers";

export const store = configureStore({
  reducer: {
    user: userReducer,
    authentication: authReducer,
    role: roleReducer,
    navigation: navigationReducer,
    employee: employeeReducer,
    roleUser: roleUserReducer,
    roleDetail: roleDetailReducer,
    dictionary: dictionaryReducer,
    approval: approvalReducer,
    leave: leaveReducer,
    symbol: symbolReducer,
    overtime: overtimeReducer,
    timekeeping: timekeepingReducer,
    timesheet: timesheetReducer,
    transaction: transactionReducer,
    payslip: payslipReducer,
    middleware: middlewareReducer,
    department: departmentReducer,
    announcement: announcementReducer,
    announcementUser: announcementUserReducer,
    shift: shiftReducer,
    period: periodReducer,
    setting: settingReducer,
    permission: permissionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
